// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPackPitch-cls1_i5o","cls2":"LoswpPackPitch-cls2_XNt LoswpPackPitch-cls1_i5o"};